export default "__VITE_ASSET__CqTe82EW__"